export interface BackgroundTaskError {
  code?: string;
  details?: unknown;
}

interface BackgroundTaskResponse {
  task_id?: string;
  error?: BackgroundTaskError | null;
}

const errorTranslationKeyByCode: Record<string, string> = {
  document_template_invalid: "document_template_invalid",
  document_validation_failed: "document_validation_failed",
  quarterly_report_own_customer_number_required:
    "quarterly_report_own_customer_number_required",
  background_task_failed: "task_failed",
};

export const getBackgroundTaskFailure = (
  response: BackgroundTaskResponse | undefined,
  fallbackMessage: string,
  translate: (key: string) => string
) => {
  const taskError = response?.error;
  const translationKey = taskError?.code
    ? errorTranslationKeyByCode[taskError.code]
    : undefined;

  return {
    message: translationKey ? translate(translationKey) : fallbackMessage,
    consoleDetails: {
      celeryTaskId: response?.task_id,
      code: taskError?.code,
      details: taskError?.details,
    },
  };
};
